module.exports = __webpack_public_path__ + "img/symbol_5.56e6dfd9.png";